import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './SuccessAnimation.module.css';
export default function SuccessAnimation() {
    return (_jsx("div", { className: styles.successCheckmark, children: _jsxs("div", { className: styles.checkIcon, children: [_jsx("span", { className: `${styles.iconLine} ${styles.lineTip}` }), _jsx("span", { className: `${styles.iconLine} ${styles.lineLong}` }), _jsx("div", { className: styles.iconCircle }), _jsx("div", { className: styles.iconFix })] }) }));
}
